import type { Dayjs } from '@duke-hq/djs';
import { StudentEnrolmentHealth, StudentRecentPaceStatus } from '@duke-hq/svc-api-db';

export default function buildLinkToEnrolments({
  dueDateStart,
  dueDateEnd,
  health,
  recentPaceStatus,
  lastActivityStart,
  lastActivityEnd,
  percent,
}: {
  health?: StudentEnrolmentHealth | StudentEnrolmentHealth[];
  recentPaceStatus?: StudentRecentPaceStatus | StudentRecentPaceStatus[];
  dueDateStart?: Dayjs;
  dueDateEnd?: Dayjs;
  lastActivityStart?: Dayjs;
  lastActivityEnd?: Dayjs;
  percent?: string;
}) {
  const params = new URLSearchParams(window.location.search);

  params.set('excludeWithdrawnDeleted', 'true');

  if (dueDateStart !== undefined) {
    params.set('dueDateStart', dueDateStart.format('YYYY-MM-DD'));
  }
  if (dueDateEnd !== undefined) {
    params.set('dueDateEnd', dueDateEnd.format('YYYY-MM-DD'));
  }
  if (lastActivityStart !== undefined) {
    params.set('lastActivityStart', lastActivityStart.format('YYYY-MM-DD'));
  }
  if (lastActivityEnd !== undefined) {
    params.set('lastActivityEnd', lastActivityEnd.format('YYYY-MM-DD'));
  }
  if (health !== undefined) {
    params.set('health', (Array.isArray(health) ? health.join(',') : health).toLowerCase());
  }
  if (recentPaceStatus !== undefined) {
    params.set(
      'recentPaceStatus',
      (Array.isArray(recentPaceStatus)
        ? recentPaceStatus.join(',')
        : recentPaceStatus
      ).toLowerCase(),
    );
  }
  if (percent !== undefined) {
    params.set('percent', percent);
  }
  // Reset Sticky Filters - this ensures old persistent filters are not applied
  // when the user navigates to the enrolments page from dashboard via filter links
  params.set('rsf', '1');

  return `/enrolments?${params.toString()}`;
}
